import MadmaxMessage from "./MadmaxMessage";
import {translate} from "../../translations/translations";

class MadmaxMessageCooldown extends MadmaxMessage {

    private _cooldownElement: HTMLElement;

    create() {
        super.create();

        this._cooldownElement = document.createElement("div");
        this._cooldownElement.classList.add("mx-message-cooldown-text");
        this._cooldownElement.textContent = ""; //"10:00";
        this.wrapper.insertBefore(this._cooldownElement, this.buttonsElement);
    }

    setTime(time) {
        this._cooldownElement.textContent = time;
    }

    hideTime() {
        $(this._cooldownElement).hide();
    }
}

export default MadmaxMessageCooldown;